import React, { Component } from 'react'
import Waypoint from 'react-waypoint'
import { observer } from 'mobx-react'

import Hero from '../components/Hero'
import About from '../components/About'
import store from '../store/'

@observer
class IndexPage extends Component {
  render() {
    const primary = '#FFDCC0'
    const secondary = '#89CECA'

    return (
      <div>
        <div>
          <Hero />
        </div>

        <Waypoint
          onPositionChange={props => {
            if (props.currentPosition == 'below') {
              store.updateBackgroundColor(primary)
              store.updateHero(true)
              store.updateAbout(false)
            } else {
              store.updateBackgroundColor(secondary)
              store.updateHero(false)
              store.updateAbout(true)
            }
          }}
        />

        <div>
          <About />
        </div>
      </div>
    )
  }
}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js